import { render, staticRenderFns } from "./CarouselEditor.vue?vue&type=template&id=7b04eba8&"
import script from "./CarouselEditor.vue?vue&type=script&lang=js&"
export * from "./CarouselEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports